import {
  useCallback, useEffect, useRef, useState
} from "react";
import { useSelector } from "react-redux";

import { getEntryOrCreate } from "Utils/Map";
import { isNullOrWhiteSpace } from "Utils/String";
import { IOmikronResult } from "Model/Omikron/IOmikronResult";
import {
  selectAddressValidationActiveProjectId,
  selectAddressValidationActiveProjectItemId,
  selectDuplicateCheckActiveProjectId,
  selectDuplicateCheckActiveProjectItemId
} from "Store/Selectors/Omikron";
import { IState } from "Model/State/IState";
import { DialogType } from "../Dialog/DialogType";
import { IUseProjectItemMap } from "./IUseProjectItemMap";

export function useProjectItemMap(type: DialogType): IUseProjectItemMap {
  const projectId = useSelector(getSelectActiveProjectIdByType(type));
  const projectItemId = useSelector(getSelectActiveProjectItemIdByType(type));
  const [selectedResultItemId, setSelectedResultItemId] = useState<string>(null);
  const [isOriginSelected, setIsOriginSelected] = useState(true);
  const selectionMapRef = useRef(new Map<string, Map<string, string>>());

  useEffect(() => {
    if (isNullOrWhiteSpace(projectId)) {
      return;
    }

    const projectItemMap = getEntryOrCreate(selectionMapRef.current, projectId, () => new Map<string, string>());

    if (isNullOrWhiteSpace(projectItemId)) {
      return;
    }

    setSelectedResultItemId(getEntryOrCreate(projectItemMap, projectItemId, () => projectItemId));
  }, [projectId, projectItemId]);

  useEffect(() => {
    setIsOriginSelected(selectedResultItemId === projectItemId);
  }, [projectItemId, selectedResultItemId]);

  const onSelectResult = useCallback(
    (result: IOmikronResult) => {
      try {
        const id = result[`@resultId`];
        selectionMapRef?.current?.get(projectId)?.set(projectItemId, id);
        setSelectedResultItemId(id);
      }
      catch(e) {
        console.warn(e);
      }
    },
    [projectId, projectItemId]
  );

  return {
    isOriginSelected,
    onSelectResult,
    projectId,
    projectItemId,
    selectedResultItemId,
    selectionMap: selectionMapRef.current,
    type
  };
}

function getSelectActiveProjectIdByType(type: DialogType): (state: IState) => string {
  return type === DialogType.AddressValidation
    ? selectAddressValidationActiveProjectId
    : selectDuplicateCheckActiveProjectId;
}

function getSelectActiveProjectItemIdByType(type: DialogType): (state: IState) => string {
  return type === DialogType.AddressValidation
    ? selectAddressValidationActiveProjectItemId
    : selectDuplicateCheckActiveProjectItemId;
}
